import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { PERSIST_CUSTOM_STYLES, REDUCER_CUSTOM_STYLES } from '../conf';

export const actionTypes = {
  GetCustomStyles: 'cms/GET_CUSTOM_STYLES',
  SetCustomStyles: 'cms/SET_CUSTOM_STYLES',
  ResetCustomStyles: 'cms/RESET_CUSTOM_STYLES',
};

const initialState = {
  customStyles: undefined,
  loading: false,
};

export const reducer = persistReducer({ storage, key: PERSIST_CUSTOM_STYLES, whitelist: ['customStyles'] }, (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GetCustomStyles:
      return { ...state, loading: true };

    case actionTypes.SetCustomStyles:
      return { ...state, customStyles: action.payload, loading: false };

    case actionTypes.ResetCustomStyles:
      return { ...state, customStyles: undefined, loading: false };

    default:
      return state;
  }
});

export const selectors = {
  getCustomStyles: (state) => {
    if (state[REDUCER_CUSTOM_STYLES]) {
      return state[REDUCER_CUSTOM_STYLES].customStyles;
    }
    return state.entities && state.entities[REDUCER_CUSTOM_STYLES] ? state.entities[REDUCER_CUSTOM_STYLES].customStyles : null;
  },
};

export const actions = {
  getCustomStyles: () => ({ type: actionTypes.GetCustomStyles }),
  setCustomStyles: (styles) => ({
    type: actionTypes.SetCustomStyles,
    payload: {
      color_first: styles.color_first,
      color_second: styles.color_second,
      font_first: styles.font_first,
      font_second: styles.font_second,
      border_radius: styles.border_radius,
    },
  }),
  resetCustomStyles: () => ({ type: actionTypes.ResetCustomStyles }),
};

export function* saga() {
  yield;
}
